module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-8-823d59d8547c321b2be072d756341504.jpg";